export default {
    active: true,
    seed: 53,
    skyType: "gradient",
    skyColor: "#1e1c1a",
    horizonColor: "#8c7964",
    lighting: "point",
    lightPosition: { x: -0.09, y: 3, z: 0.33 },
    fog: 0.43,
    flatShading: true,
    playArea: 1.08,
    ground: "canyon",
    groundYScale: 50,
    groundTexture: "none",
    groundColor: "#353535",
    groundColor2: "#454545",
    dressing: "hexagons",
    dressingAmount: 300,
    dressingColor: "#fe921b",
    dressingScale: 0.5,
    dressingVariance: { x: 2, y: 8, z: 2 },
    dressingUniformScale: true,
    dressingOnPlayArea: 0.03,
    grid: "none",
    gridColor: "#ccc",
    shadow: false,
};
